/* eslint-disable */
export default {
  download: 'Download',
  play: 'Play',
  pause: 'Pause',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
